import React from 'react'

export default function Section7() {
  return (
    <>
        <div className='bg-bg h-max   '>
            <div className='md:pt-20 px-6 space-y-4 md:px-10'>
                <div className='text-left text-white text-[24px] px-2 pt-10 font-medium md:font-semibold'>ARE YOU READY?</div>
                <div className='text-left text-white text-[35px] md:text-[50px] font-semibold md:font-bold px-2 md:leading-none md:my-6 '  >Download the free app and save money on groceries now</div>
                    <div className='flex space-x-3 justify-center md:justify-start md:py-8'>
                        <img src='https://assets-global.website-files.com/5e4482baa13a1926b23e2187/5e4dd1e309d48fb5d5f2be24_Apple%201.svg' alt='/' />
                        <img src='https://assets-global.website-files.com/5e4482baa13a1926b23e2187/5e4dd1dd09d48f7b3cf2bdf4_Google%201.svg' alt="/" />
                    </div>
                </div>
                <img alt='/' className='pt-12 mx-auto translate-y-8  md:hidden' src='https://assets-global.website-files.com/5e4482baa13a1926b23e2187/607f342e86767b926943b932_flashfood-phone-cta-sfw.jpg' />    
                <img alt='/' className=' w-screen relative ' src='https://assets-global.website-files.com/5e4482baa13a1926b23e2187/6079f749733e292a82fae3ae_footer-dark-wave-p-1600.png' />
            </div>
            
    </>
  )
}
